import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

const ShipFromColumn = ({ shipFromId, shipFromNameFallback }) => {
  const shipFroms = useSelector(Global.selectSellerShipFroms);

  if (!shipFromId || !shipFroms.length) {
    return <span>{shipFromNameFallback ?? ''}</span>;
  }
  const shipFrom = shipFroms.find((sf) => sf.shipFromId === shipFromId);
  return <span>{shipFrom?.name ?? shipFromNameFallback ?? ''}</span>;
};

ShipFromColumn.propTypes = {
  shipFromId: PropTypes.string.isRequired,
};

export default React.memo(ShipFromColumn);
